import { render, staticRenderFns } from "./alarmSend.vue?vue&type=template&id=46d1bb2f&"
import script from "./alarmSend.vue?vue&type=script&lang=js&"
export * from "./alarmSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports